import apiRequest from './handler';

const fetchApplicationsService = {

    getApplicationsForStatusCode: async (latest_status, filters={}, setIsAuthenticated, navigate ) => {
        try {
            let queryParams = new URLSearchParams();
            if (latest_status) {
                queryParams.append('latest_status', latest_status);
            }
            Object.keys(filters).forEach(key => {
                const value = filters[key];
                queryParams.append(key, value);
            });
            let query = queryParams.toString();
            const response = apiRequest(
                `/reseller/applications/referral-code?${query}`,
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching applications:', error);
            throw error;
        }
    },

    getApplicationCountForReferralByLoanType: async (loanTypeCode, filters, setIsAuthenticated, navigate) => {
        try {
            let queryParams = new URLSearchParams();
            queryParams.append('loan_type_code', loanTypeCode);
            Object.keys(filters).forEach(key => {
                const value = filters[key];
                queryParams.append(key, value);
            });
            let query = queryParams.toString();
            const response = apiRequest(
                `/reseller/applications/count?${query}`,
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching applications:', error);
            throw error;
        }
    },

    getLoanTypesCountForReferral: async (filters, setIsAuthenticated, navigate) => {
        try {
            let queryParams = new URLSearchParams();
            Object.keys(filters).forEach(key => {
                const value = filters[key];
                queryParams.append(key, value);
            });
            let query = queryParams.toString();
            const response = apiRequest(
                `/reseller/loan-type/count?${query}`,
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching applications:', error);
            throw error;
        }
    }
};

export default fetchApplicationsService;
